import { getActionItems } from 'hb-react/frontoffice/apps/MediaCenter/components/FoldersRenderer/utils';
import { useMediaCenterPathContext } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterPathContext';
import FolderThumbnail from 'hb-react/shared/components/Thumbnails/FolderThumbnail';

import { actionItemsIcons } from '../actionItemsIcons';

const FoldersRenderer = ({ item }) => {
  const { mediaCenterFolderPath } = useMediaCenterPathContext();

  return (
    <MediaCenterFolderThumbnail
      folder={item}
      mediaCenterFolderPath={mediaCenterFolderPath}
    />
  );
};

export const MediaCenterFolderThumbnail = ({
  folder,
  mediaCenterFolderPath,
}) => {
  const {
    updated_at: updatedAt,
    total_items: totalItems,
    cover_picture_file_url: url,
    name,
    uuid,
  } = folder;

  const tag = n__('%{count} item', '%{count} items', totalItems).i__({
    count: totalItems,
  });

  const folderUrl = mediaCenterFolderPath(uuid);

  const sharedResourceUrl = `${window.location.origin}${folderUrl}`;

  return (
    <FolderThumbnail
      header={{
        actions: getActionItems(sharedResourceUrl, actionItemsIcons),
        date: updatedAt,
        owner: null,
        withUserInformations: false,
      }}
      link={{
        to: {
          pathname: mediaCenterFolderPath(uuid),
          search: window.location.search,
        },
      }}
      tag={tag}
      content={{
        name,
        url,
      }}
      bottom={{
        text: name,
      }}
    />
  );
};

export default FoldersRenderer;
